var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNotes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.366,
    height: 8.244,
    viewBox: "0 0 12.366 8.244",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_sort_24px",
    d: "M3,14.244H7.122V12.87H3ZM3,6V7.374H15.366V6Zm0,4.809h8.244V9.435H3Z",
    transform: "translate(-3 -6)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNotes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-notes.e214b9866af40159959d24c1373c5754.svg";